import "./Services.module.css";
import Header from "@/reusable_sections/Header";
import Expertise from "./sections/Expertise";
import IndividualApproach from "./sections/IndividualApproach";
import Pricing from "./sections/Pricing";
import Footer from "@/reusable_sections/Footer";
export default function ServicesPage() {
  return <div>
      <Header />
      <Expertise />
      <IndividualApproach />
      <Pricing />
      <Footer />
    </div>;
}